module.exports = __webpack_public_path__ + "64cc604e.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/save_search.png
// module id = 1889
// module chunks = 0 1 15 17 22